module.exports = __webpack_public_path__ + "static/media/chevron-down-solid.2c0862a6.svg";